import {inject, injectable} from "tsyringe";
import {h} from "../../../../tracejs/src/utils/JSXFactory";
import {BaseDialogViewModel} from "../../common/BaseDialogViewModel";
import {Client} from "../../../../tracejs/src/net/jsonrpc/Client";
import {IDialogSettings} from "../../common/IDialogSettings";
import {AddressBookManager} from "../../../model/EditTracedo/AddressBookManager";
import {Addressbook} from "../../../entities/Addressbook";
import {i18n} from "i18next-ko";

export interface CreateDistributionPricelistProps extends IDialogSettings {
    subjectid: number;
}

@injectable()
export class CreateDistributionPricelist extends BaseDialogViewModel<CreateDistributionPricelistProps> {

    // nastaveni dropdownu pro vyber adresy
    private addressComboConfig: kendo.ui.DropDownListOptions;

    private addressbookManager: AddressBookManager;

    private customers: KnockoutObservableArray<any> = ko.observableArray();
    private subjectId: number = null;

    private file: KnockoutObservable<File|null> = ko.observable(null);
    private fileData: KnockoutObservable<string|null> = ko.observable(null);

    private customerId: KnockoutObservable<number> = ko.observable();
    private addressbookId: KnockoutObservable<number> = ko.observable();

    constructor(@inject(Client) rpc: Client, @inject(AddressBookManager) addressbookManager: AddressBookManager) {
        super(rpc);
        this.addressbookManager = addressbookManager;
    }

    async startup(): Promise<any> {
        console.log("startup");

        this.subjectId = this.settings.subjectid;

        this.addressComboConfig = {
            optionLabel: i18n.t('trackAndTrace.edit.selectAddress'),
            dataTextField: 'info',
            dataValueField: 'addressbookId',
            filter: 'contains',
            autoBind: true,
            minLength: 0,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: this.getAddressbooksForSearchedText
                }
            },
            dataBound: (e: kendo.ui.DropDownListDataBoundEvent) => {
                let selectedObject = e.sender.dataItem(e.sender.select());
                if (selectedObject.addressbookId !== '') {
                    this.addressbookId(selectedObject.addressbookId);
                }
            },
            change: (e: kendo.ui.DropDownListChangeEvent) => {
                let selectedObject = e.sender.dataItem(e.sender.select());
                this.addressbookId(selectedObject.addressbookId);
            }
        };

        this.customers = ko.mapping.fromJS(
            await this.rpc.call('subject.getCustomers', {
                query: {
                    select: 'subjectId,name',
                    sort: [{field: 'name', dir: 'asc'}]
                }
            })
        );

        return super.startup();
    }


    private getAddressbooksForSearchedText = async (options: kendo.data.DataSourceTransportReadOptions) => {
        let searchedText = options.data.filter && options.data.filter.filters && options.data.filter.filters[0] ?
            (options.data.filter.filters[0] as any).value :
            '';

        let addresses: Addressbook[] = await this.addressbookManager.getAddressbooksWithText(searchedText);

        addresses.forEach((addr: Addressbook) => {
            (addr as any).info = addr.name +
                (addr.town ? ', ' + addr.town :     '') +
                (addr.zipCode ? ', ' + addr.zipCode : '') +
                (addr.countryId ? ', ' + addr.country.iso : '');
        });

        options.success(addresses);
    }


    async save(): Promise<any> {
        const input = document.getElementById('excelFile') as HTMLInputElement;
        if (!input.files || input.files.length === 0) return -1;

        const file = input.files[0];
        const base64Data = await this.fileToBase64(file);

        await this.rpc.call('distributionPricelist.createPricelist', {
            fileData: base64Data,
            fileName: file.name,
            addressbookId: this.addressbookId(),
            customerId: this.customerId(),
        })

        return true;
    }

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = (reader.result as string).split(',')[1]; // remove "data:*/*;base64," prefix
                resolve(base64String);
            };
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    }

    public dialogTemplate = (
        labelCol: string = 'col-md-4',
        inputCol: string = 'col-md-8'
    ): HTMLElement => (
        <div>
            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'customerIdInput', i18n: 'common.captions.customer'"></label>
                <div className="col-md-10">
                    <input className="w-100" id="customerIdInput" data-bind="kendoDropDownList: {
                        data: $root.customers,
                        dataTextField: 'name',
                        dataValueField: 'subjectId',
                        optionLabel: '-',
                        filter: 'contains',
                        value: customerId,
                        animation: false
                    }"/>
                </div>
            </div>

            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'addressIdInput', i18n: 'common.captions.address'"></label>
                <div className="col-md-10">

                    <input type="text" className="w-100" id="checkpointAddressbookId"
                           data-bind="value: addressbookId, kendoDropDownList: $root.addressComboConfig"/>
                </div>
                </div>

                <div className="row mb-2">
                    <label className="inline col-md-3 col-form-label" data-bind="uniqueFor: 'excelFile',  i18n: 'common.captions.pricelist'"></label>
                    <div className="col-md-9">
                        <input id='excelFile' className="form-control" type="file"/>
                    </div>
                </div>

            </div>
    )
}